import { render, staticRenderFns } from "./imgColorPop.vue?vue&type=template&id=4b251474&scoped=true&"
import script from "./imgColorPop.vue?vue&type=script&lang=js&"
export * from "./imgColorPop.vue?vue&type=script&lang=js&"
import style0 from "./imgColorPop.vue?vue&type=style&index=0&id=4b251474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b251474",
  null
  
)

export default component.exports